import React, { useEffect } from 'react'
import './style/ProductPage.css'
import './style/KontaktPage.css'
import HeroImg from '../resources/fotosKathi/2.jpg'

const KontaktPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className='kontaktPage'>
      <div
        className='productPageImageDiv'
        style={{ backgroundImage: `url(${HeroImg})` }}
      >
        <div className='textDivProductPage'>
          <h1>Trete mit uns in Kontakt!</h1>
          <p>Das Team der Kaffeebrennerei heißt dich herzlich willkommen!</p>
        </div>
      </div>
      <div className='kontaktPageContent'>
        <h2>So erreichst du uns</h2>
        <p>
          Ob du Fragen zu unseren Kaffees hast, an einer Zusammenarbeit
          interessiert bist oder einfach nur eine nette Nachricht hinterlassen
          möchtest – wir freuen uns, von dir zu hören!
        </p>

        <h3>Kontaktinformationen</h3>
        <p>
          <strong>E-Mail:</strong> office@kaffeebrennerei.at
        </p>
        <p>
          <strong>Telefon:</strong> +43 676/ 7700272
        </p>
        <p>
          <strong>Adresse:</strong> Innviertlerstr. 19, 4911 Tumeltsham
        </p>

        <h3>Öffnungszeiten</h3>
        <p id='oidascheisdreck'>
          Keine fixen Öffnungszeiten – aber wir sind nur einen Anruf entfernt!
        </p>

        <h3>Besuche uns gerne vor Ort!</h3>
        <p>
          In unserer kleinen Rösterei kannst du unsere Kaffees direkt probieren,
          mit uns plaudern oder einfach den Duft frisch gerösteter Bohnen
          genießen.
        </p>
      </div>
    </div>
  )
}

export default KontaktPage
